import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import GameBoard from './components/GameBoard';
import GameModeSelector from './components/GameModeSelector';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import { AnimatePresence } from 'framer-motion';

function Home({ gameMode, setGameMode }) {
  return (
    <>
      <header className="pt-16 pb-8 px-4 text-center">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-center items-center mb-6 overflow-visible">
            <h1 className="flex items-baseline whitespace-nowrap overflow-visible py-4">
              <span className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter text-slate-900">
                Connect
              </span>
              <span className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter italic text-transparent bg-clip-text bg-gradient-to-br from-indigo-500 via-blue-600 to-cyan-400 ml-[-2px] pr-4 sm:pr-8">
                Go
              </span>
            </h1>
          </div>
          <p className="text-lg md:text-xl text-slate-500 max-w-2xl mx-auto leading-tight font-medium px-4">
            {gameMode === 'duo' ? "Create meaningful connections, one conversation at a time." : "Meeting new people? Play ConnectGo together!"}
          </p>
        </div>
      </header>

      <main className="pb-20">
        <AnimatePresence mode="wait">
          {!gameMode ? (
            <GameModeSelector onSelect={setGameMode} />
          ) : (
            <GameBoard mode={gameMode} onExit={() => setGameMode(null)} />
          )}
        </AnimatePresence>
      </main>
    </>
  );
}

function App() {
  const [gameMode, setGameMode] = useState(null);

  return (
    <Router>
      <div className="min-h-screen bg-[#FDFDFD] text-slate-900 font-sans selection:bg-indigo-100 flex flex-col">
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home gameMode={gameMode} setGameMode={setGameMode} />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </div>

        <footer className="text-center py-12 text-slate-400 text-[11px] sm:text-[13px] border-t border-slate-100 px-8 bg-white">
          <div className="max-w-3xl mx-auto space-y-4">
            <p className="leading-relaxed font-medium">
              © 2026 Well x Design. All Rights Reserved.
            </p>
            <div className="flex justify-center items-center gap-6">
              <Link to="/terms" className="hover:text-indigo-600 transition-colors uppercase tracking-widest font-normal">
                Terms & conditions
              </Link>
              <span className="w-1 h-1 bg-slate-200 rounded-full" />
              <Link to="/privacy" className="hover:text-indigo-600 transition-colors uppercase tracking-widest font-normal">
                Privacy policy
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;